import i from './order-list-customer.container';

export default i;
